import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "20",
  fill: "none",
  viewBox: "0.42 0.18 15.65 15.63"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#0000E7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".5",
  d: "M8.25 6.003v-.667M8.25 10v.667M7.117 9.533c.2.267.466.467.8.467h.733c.533 0 .933-.4.933-.933 0-.4-.266-.8-.733-.934L7.583 7.8a.914.914 0 0 1-.666-1.133C7.05 6.267 7.45 6 7.85 6h.733c.334 0 .667.2.8.467"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#0000E7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M8.25 2c3.333 0 6 2.667 6 6s-2.667 6-6 6-6-2.667-6-6 2.667-6 6-6"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#0000E7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M8.25 2c3.333 0 6 2.667 6 6s-2.667 6-6 6-6-2.667-6-6 2.667-6 6-6"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }